<template>
  <div class="content">
    <div class="box">
      <p class="chinese-name">成功案例</p>
      <p class="english-name">SUCCESSFUL CASES</p>
      <div class="swiper-content">
        <a-carousel :dots="false" ref="swiper">
          <div class="swiper-box" v-for="(item, index) in imgList" :key="index">
            <div>
              <img :src="item && item[0] && item[0].url" @click="imgChose(0)" />
              <div class="left-title">
                {{ item[0] && item[0].name }}
              </div>
            </div>
            <div>
              <div class="img-list">
                <img
                  :src="item && item[1] && item[1].url"
                  @click="imgChose(1)"
                />
                <div class="right-title">
                  {{ item[1] && item[1].name }}
                </div>
              </div>
              <div class="img-list">
                <img
                  :src="item && item[2] && item[2].url"
                  @click="imgChose(2)"
                />
                <div class="right-title">
                  {{ item[2] && item[2].name }}
                </div>
              </div>
              <div class="img-list">
                <img
                  :src="item && item[3] && item[3].url"
                  @click="imgChose(3)"
                />
                <div class="right-title">
                  {{ item[3] && item[3].name }}
                </div>
              </div>
              <div class="img-list">
                <img
                  :src="item && item[4] && item[4].url"
                  @click="imgChose(4)"
                />
                <div class="right-title">
                  {{ item[4] && item[4].name }}
                </div>
              </div>
            </div>
          </div>
        </a-carousel>
      </div>
    </div>
    <a-modal
      :visible="!!img"
      :footer="null"
      :closable="false"
      width="850px"
      @cancel="img = ''"
      style="background: rgba(0, 0, 0, 0)"
      :maskClosable="false"
    >
      <div style="text-align: center">
        <img width="600px" :src="img.url" alt="" />
      </div>
      <div class="arrow">
        <p @click="change(true)" style="top: 200px">
          <a-icon type="left" style="color: white; font-size: 50px" />
        </p>
        <p @click="change(false)" style="top: 200px">
          <a-icon type="right" style="color: white; font-size: 50px" />
        </p>
      </div>
      <div class="close-tag" @click="img = ''">
        <a-icon type="close" />
      </div>
      <div class="tag">{{ img.picRemark }}</div>
    </a-modal>
  </div>
</template>

<script>
import { getSuccess, getCommonDetail } from "@/api/translation.js";
import { getFileDetails } from "@/api/file.js";
export default {
  name: "success-case",
  data() {
    return {
      imgList: [],
      img: "",
      picRemark: "",
    };
  },
  created() {
    this._getSuccess();
  },
  methods: {
    imgChose(item) {
      const list = this._.cloneDeep(this.imgList).flat();
      this.img = list[item];
      this.picRemark = item;
    },
    change(isprev) {
      const index = this._.cloneDeep(this.imgList)
        .flat()
        .findIndex((item) => item.url === this.img);
      const list = this._.cloneDeep(this.imgList).flat();
      if (isprev && index !== 0) {
        this.picRemark = this.picRemark - 1;
        if (this.picRemark < 0) {
          this.img = "";
          return;
        }
        this.img = list[this.picRemark];
      } else {
        this.picRemark = this.picRemark + 1;
        if (this.picRemark > list.length - 1) {
          this.img = "";
          return;
        }
        this.img = list[this.picRemark];
      }
    },
    choose(isprev) {
      if (isprev) {
        this.$refs && this.$refs.swiper.prev();
      } else {
        this.$refs && this.$refs.swiper.next();
      }
    },
    _getSuccess() {
      this.imgList = JSON.parse(JSON.stringify([]));
      getSuccess().then(async (res) => {
        const list = this._.get(res, "data.records", []);
        for (let i of list) {
          let resI = await getCommonDetail(i.picCode, i.tenantCode);
          let img = await getFileDetails(i.appCode, i.tenantCode, [
            this._.get(resI, "data.contentPicFileDtoList.0.fileCode"),
          ]);
          this.imgList.push({
            name: this._.get(resI, "data.picName", ""),
            url: this._.get(
              Object.values(this._.get(img, "data")),
              "0.fileHttpUrl"
            ),
            picRemark: this._.get(
              resI,
              "data.contentPicFileDtoList[0].picRemark",
              ""
            ),
          });
        }
        this.imgList = this.imgList.reduce((acc = [], item, index) => {
          // item.url = `http://10.10.152.115/` + item.url
          if (index === 0) {
            acc[0] = [item];
          } else if ((index + 1) % 6 === 0) {
            acc.push([item]);
          } else {
            acc[acc.length - 1].push(item);
          }
          return acc;
        }, []);
      });
    },
  },
};
</script>

<style scoped lang='less'>
p {
  margin: 0;
  padding: 0;
}
.content {
  width: 100%;
  position: relative;
  margin-top: 20px;
}
.box {
  width: 1140px;
  height: 480px;
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  background: rgba(255, 255, 255, 1);
  cursor: pointer;
}
.swiper-content {
  height: 360px;
  width: 1140px;
  position: relative;
  .swiper-box {
    font-size: 0px;
    > div {
      display: inline-block;
      font-size: 0px;
      vertical-align: middle;
    }
    > div:first-of-type {
      width: 560px;
      height: 360px;
      margin-right: 30px;
      position: relative;
      > img {
        width: 560px;
        height: 360px;
      }
      .left-title {
        position: absolute;
        left: 19px;
        bottom: 8px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fff;
        z-index: 2;
      }
    }
    > div:last-of-type {
      width: 549px;
      height: 360px;
      text-align: left;
      .img-list {
        position: relative;
        display: inline-block;
        width: 260px;
        height: 170px;
        img {
          width: 260px;
          height: 170px;
        }
        .right-title {
          width: 90%;
          // background-color: aqua;
          font-size: 14px;
          white-space: nowrap; /*把文本强制显示在一行*/
          overflow: hidden; /*隐藏超出部分的文字*/
          text-overflow: ellipsis; /*超出显示省略号*/
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fff;
          position: absolute;
          left: 19px;
          bottom: 9px;
        }
      }
      .img-list:first-of-type,
      .img-list:nth-of-type(2) {
        margin-bottom: 20px;
      }
      .img-list:nth-of-type(2n) {
        margin-left: 29px;
      }
    }
  }
}
.arrow {
  cursor: pointer;
  p {
    position: absolute;
    width: 20px;
    height: 34px;
    top: 163px;
    img {
      width: 20px;
      height: 34px;
    }
  }
  p:first-of-type {
    left: -40px;
  }
  p:last-of-type {
    right: -36px;
  }
}
.chinese-name {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  position: absolute;
  left: 50%;
  top: 40px;
  transform: translateX(-50%);
  z-index: 999;
}
.english-name {
  font-size: 80px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #faf5f5;
  position: relative;
}
.swiper-box img:hover {
  transition: 0.3s ease;
  transform: scale(1.1, 1.1);
}
/deep/ .ant-modal-content {
  background: rgba(0, 0, 0, 0);
  box-shadow: none;
  margin-top: 60px;
}
/deep/ .ant-modal-mask {
  background: rgba(0, 0, 0, 0.8);
}
.close-tag {
  position: absolute;
  top: 300px;
  right: 100px;
  font-size: 30px;
  color: white;
  top: -80px;
  right: -200px;
  cursor: pointer;
}
.tag {
  position: absolute;
  text-align: center;
  font-size: 15px;
  color: #fff;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/home/translationService/siderContent-02.vue